 /* ==========================================================
[ 目次 ]

<body>クラス設定
スムース スクロール

========================================================== */

/* ---------------------------------------------
*   <body>クラス設定
--------------------------------------------- */
/**
 * <body>要素に、ユーザーのOS・デバイスとブラウザ等に関数情報をクラスとして付与する
 * OS・デバイス: ios, iphone, ipad, android, androidphone, androidtablet, windows, mac
 * ブラウザ: ie, edge, chrome, firefox, safari
 */
$(function () {
    'use strict';

    $('body').addClass(function () {
        var bodyClasses = '';

        // プラットフォーム判定
        if (is.ios()) {
            bodyClasses += ' ios';

            if (is.iphone()) {
                bodyClasses += ' iphone';
            } else if (is.ipad()) {
                bodyClasses += ' ipad';
            }
        } else if (
            window.navigator.userAgent.toLowerCase().indexOf('macintosh') >
                -1 &&
            'ontouchend' in document
        ) {
            bodyClasses += ' ipad';
        } else if (is.android()) {
            bodyClasses += ' android';

            if (is.androidPhone()) {
                bodyClasses += ' androidphone';
            } else if (is.androidTablet()) {
                bodyClasses += ' androidtablet';
            }
        } else if (is.windows()) {
            bodyClasses += ' windows';
        } else if (is.mac()) {
            bodyClasses += ' mac';
        }

        // ブラウザ判定
        if (is.ie()) {
            bodyClasses += ' ie';

            if (is.ie(10)) {
                bodyClasses += ' ie10';
            } else if (is.ie(11)) {
                bodyClasses += ' ie11';
            }
        } else if (
            is.edge() ||
            window.navigator.userAgent.toLowerCase().indexOf('edg') > -1
        ) {
            bodyClasses += ' edge';
        } else if (is.chrome()) {
            bodyClasses += ' chrome';
        } else if (is.firefox()) {
            bodyClasses += ' firefox';
        } else if (is.safari()) {
            bodyClasses += ' safari';
        }

        return bodyClasses;
    });
});

/* ---------------------------------------------
*   magnific-popup
--------------------------------------------- */
$(function () {
    $('.js-mfp-inline').magnificPopup({
        type: 'inline',
        closeMarkup:
            '<button title="%title%" type="button" class="c-modal__close close-btn"><img src="https://www.junonline.jp/common/img/for-shopify/icon_close.svg"></button>',
        callbacks: {
            open: function () {
                closeBtn();
            }
        }
    });

    function closeBtn() {
        $('.close-btn').on('click', function () {
            $('.c-modal').magnificPopup('close');
        });
    }
});

/* ---------------------------------------------
*   validationEngine
--------------------------------------------- */
$(document).on('ready', function () {
    $('#register').validationEngine({
        promptPosition: 'bottomLeft'
    });
    $('.js-form-address').validationEngine({
        promptPosition: 'bottomLeft'
    });
    $('.js-form-point').validationEngine({
        promptPosition: 'bottomLeft'
    });
});

/* ---------------------------------------------
*   半角→全角
--------------------------------------------- */
$(function () {
    $('.js-change-zenkaku').blur(function () {
        changeHan($(this));
    });

    changeHan = function (ele) {
        var val = ele.val();
        var han = val.replace(
            /[A-Za-z0-9-!"#$%&'()=<>,.?_\[\]{}@^~\\]/g,
            function (s) {
                return String.fromCharCode(s.charCodeAt(0) + 65248);
            }
        );
        $(ele).val(han);
    };
});

/* ---------------------------------------------
*   全角→半角
--------------------------------------------- */
$(function () {
    $('.js-change-hankaku').blur(function () {
        changeZen($(this));
    });

    changeZen = function (ele) {
        var val = ele.val();
        var han = val.replace(
            /[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g,
            function (s) {
                return String.fromCharCode(s.charCodeAt(0) - 65248);
            }
        );
        $(ele).val(han);
    };
});
